function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { PatternFormat } from 'react-number-format';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
const StyledTextField = styled(TextField)(({
  theme
}) => ({
  '& .MuiInputBase-root': {
    fontFamily: '"AvenirLTPro-Book", sans-serif',
    fontWeight: "lighter",
    color: theme.palette.default.contrastText,
    letterSpacing: "0.14994px"
  },
  "& .MuiOutlinedInput-root:hover:not(.Mui-disabled):not(.Mui-error):before": {
    borderColor: theme.palette.custom.textFieldHover
  },
  "& .MuiInput-underline:hover:not(.Mui-disabled):not(.Mui-error):before": {
    borderColor: theme.palette.custom.textFieldHover,
    borderBottomWidth: "2px"
  }
}));

/**
 *
 * @param {*} props
 */
const PhoneFormatCustom = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    inputRef,
    onChange,
    ...other
  } = props;
  return /*#__PURE__*/React.createElement(PatternFormat, _extends({}, other, {
    getInputRef: inputRef,
    onValueChange: values => {
      onChange({
        target: {
          value: values.value
        }
      });
    },
    format: "(###) ###-####"
    // this prop converts the value from a string to a number without setting the value as values.formattedValue which looks weird when typing in to the field
    ,
    valueIsNumericString: true,
    mask: "_"
  }));
});
PhoneFormatCustom.displayName = "PhoneFormatCustom";

/**
 *
 * @param {*} props
 */
const PhoneInput = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(StyledTextField, {
  id: props.id || props.testid,
  ref: ref,
  select: props.select,
  autoFocus: props.autoFocus,
  autoComplete: props.autoComplete || "tel",
  error: props.error,
  label: props.label,
  value: props.value,
  margin: props.margin || 'normal' // none, dense, or normal
  ,
  onChange: props.onChange,
  onKeyPress: props.onKeyPress,
  onBlur: props.onBlur,
  fullWidth: props.fullWidth,
  helperText: props.helperText || props.error,
  InputProps: {
    inputComponent: PhoneFormatCustom
  },
  sx: {
    backgroundColor: props.disabled ? '#f7f7f7' : null,
    letterSpacing: "0.14994px"
  },
  required: props.required,
  variant: props.variant || 'outlined',
  disabled: props.disabled
}));
PhoneInput.displayName = "PhoneInput";
export default PhoneInput;